var map = {
	"./data": 479,
	"./data.json": 479,
	"./en-US": 480,
	"./en-US.js": 480,
	"./fr": 481,
	"./fr-CA": 482,
	"./fr-CA.js": 482,
	"./fr.js": 481,
	"./translations.csv": 483
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;



//////////////////
// WEBPACK FOOTER
// ../public/messages ^\.\/.*$
// module id = 478
// module chunks = 0